import { IFileDownloadResponse } from '@common/interfaces/request'
import { Action } from 'redux'
import { takeEvery, put } from 'redux-saga/effects'
import { download } from '../../helpers/helpers'
import { putPromise } from '../../helpers/redux'
import { ADD_NOTE_SUCCESS } from '../notes/actions'
import { EXPORT_NEWSFEED_SUCCESS, EXPORT_NEWSFEED_FAILURE, showNewsfeed } from './actions'

export function* exportNewsfeed() {
  yield takeEvery(EXPORT_NEWSFEED_SUCCESS, function* (action: IFileDownloadResponse & Action) {
    try {
      const data = action.data
      yield download(data, data.name)
    } catch (error) {
      yield put({ type: EXPORT_NEWSFEED_FAILURE, error: error as Error })
    }
  })
}

// A reply that tags a client or entity links it to the headline server-side.
export function* refreshHeadlineAfterReply() {
  yield takeEvery(
    ADD_NOTE_SUCCESS,
    function* (action: Action & { data?: { newsfeedHeadlineId?: string | null } }) {
      const newsfeedHeadlineId = action.data?.newsfeedHeadlineId
      if (newsfeedHeadlineId) {
        yield putPromise(showNewsfeed(newsfeedHeadlineId, { skipLoader: true }))
      }
    },
  )
}
